import React from "react"

import { Link } from "gatsby-plugin-modal-routing-3"
import { site, sites } from "../../../utils/site"

const TYPE_SITE = "site"
const TYPE_EXTLINK = "ext-link"

const SUBTYPE_PAGE = "page"
const SUBTYPE_COLLECTION = "collection"
const SUBTYPE_POPIN = "pop-in"

function CtaLink({ ctaLink, activeclassname, ...props }) {
  // - Lien externe : <a href="https://google.fr">google</a>
  //
  // - lien interne :
  //       meme site : <Link to="/ma/route">Ma route</Link>
  //
  //       autre site : <a href="https://site/mon/autre/route">Mon autre route</a>
  //
  // - Ajouter asModal pour les liens pop-in

  if (!ctaLink) {
    return (
      <Link
        to="/page-404"
        {...props}
      ></Link>
    )
  }
  if (typeof ctaLink === "string") {
    return (
      <Link
        to={ctaLink}
        {...props}
      ></Link>
    )
  }
  if (ctaLink.type === TYPE_EXTLINK) {
    const rel =
      (ctaLink.noreferrer && "noreferrer ") +
        (ctaLink.nofollow && "nofollow") || ""
    
    if (ctaLink.url.startsWith("#" || "/#")) {
      ctaLink.url = ctaLink.url.replace("/", "")
    } else {
      if (!ctaLink.url.startsWith("http" || "https")) {
        ctaLink.url = "https://" + ctaLink.url
      } 
    }

    return (
      <a
        {...props}
        href={ctaLink.url}
        target={ctaLink.targetBlank ? "_blank" : "_self"}
        rel={rel}
      ></a>
    )
  }
  if (ctaLink.type === TYPE_SITE) {
    if (ctaLink.site === site) {
      switch (ctaLink.subType) {
        case SUBTYPE_PAGE:
          return (
            <Link
              {...props}
              activeClassName={props.activeclassname}
              to={
                ctaLink?.itemData?.attributes.route
                  ? ctaLink?.itemData?.attributes.route
                  : "/page-404"
              }
              // asModal={ctaLink?.itemData?.attributes.isPopIn}
            ></Link>
          )
        case SUBTYPE_COLLECTION:
          return (
            <Link
              {...props}
              activeClassName={props.activeclassname}
              to={
                ctaLink?.itemData?.attributes.autoRoute
                  ? ctaLink?.itemData?.attributes.autoRoute
                  : "/page-404"
              }
            ></Link>
          )
        case SUBTYPE_POPIN:
          return (
            <Link
              {...props}
              activeClassName={props.activeclassname}
              to={
                ctaLink?.itemData?.attributes.route
                  ? ctaLink?.itemData?.attributes.route
                  : "/page-404"
              }
              asModal
            ></Link>
          )
        default:
          return (
            <Link
              to="/page-404"
              {...props}
            ></Link>
          )
      }
    } else {
      switch (ctaLink.subType) {
        case SUBTYPE_PAGE:
          return (
            <a
              {...props}
              href={
                sites[ctaLink.site].baseUrl +
                ctaLink?.itemData?.attributes.route
              }
              // asModal={ctaLink?.itemData?.attributes.isPopIn}
            ></a>
          )
        case SUBTYPE_COLLECTION:
          return (
            <a
              {...props}
              href={
                sites[ctaLink.site].baseUrl +
                ctaLink?.itemData?.attributes.autoRoute
              }
            ></a>
          )
        case SUBTYPE_POPIN:
          throw new Error(
            "Les popin vers les autres sites ne sont pas encore supportées "
          )
        default:
          return (
            <Link
              to="/page-404"
              {...props}
            ></Link>
          )
      }
    }
  }
  return (
    <Link
      to="/page-404"
      {...props}
    ></Link>
  )
}

export default CtaLink
